import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import * as _ from 'lodash';

import { AuthService } from './../../../services/auth.service';
import { MemberService } from './../../../rest/api/member.service';
import { HelperService } from './../../../services/helper.service';
import { CountryService } from './../../../rest/api/country.service';

@Component({
  selector: 'app-profile-edit',
  templateUrl: './profile-edit.component.html',
  styleUrls: ['./profile-edit.component.scss']
})
export class ProfileEditComponent implements OnInit {
  @ViewChild('countryText') countryText: ElementRef;

  accessToken: any;
  updateMemberForm: FormGroup;

  userData: any;
  loader = true;

  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;

  loading = true;
  countryData: any;
  filteredCountryData: any;
  selectedCountry: any;

  companyRoles: any;

  constructor(
    public router: Router,
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    public countryService: CountryService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.authService.companyRoles.subscribe((value) => {
      this.companyRoles = value;
    });
  }

  ngOnInit() {
    this.companyRoles = this.companyRoles ? this.companyRoles : this.authService.getCompanyRoles();
    this.authService.membersDataSubscription.subscribe(response => {
      if (response) {
        this.userData = response;
        this.updateFormInit(this.userData);
        this.getCountryData();
      }
    });
  }

  getCountryData() {
    this.countryService.getCountryName().subscribe((res: any) => {
      this.countryData = res && res.data ? res.data : [];
      this.filteredCountryData = res && res.data ? res.data : [];
      let country;
      if (this.userData && this.userData.country_code && this.userData.country_code !== '') {
        const userCountryCode = this.userData.country_code;
        country = this.countryData ? _.find(this.countryData, { alpha_code: userCountryCode}) : undefined;
      } else {
        country = this.countryData ? _.find(this.countryData, { alpha_code: 'JP' }) : undefined;
      }
      if (country) {
        this.selectedCountry = country;
      } else {
        this.selectedCountry = this.countryData && this.countryData[0] ? this.countryData[0] : undefined;
      }
      this.loader = false;
    }, err => {
      this.countryData = [];
      this.loader = false;
    });
  }

  changeCountry(country) {
    if (this.countryText) {
      this.countryText.nativeElement.value = '';
      this.filteredCountryData = this.countryData;
    }
    this.selectedCountry = country;
  }

  searchCountry(event) {
    if (event.target.value === '') {
      this.filteredCountryData = this.countryData;
    } else {
      this.filteredCountryData = _.filter(this.filteredCountryData, _.flow(
        _.identity,
        _.values,
        _.join,
        _.toLower,
        _.partialRight(_.includes, event.target.value)
      ));
    }
  }

  updateFormInit(userData) {
    if (this.companyRoles === 'owner') {
      this.updateMemberForm = this.fb.group({
        first_name: [userData.first_name, [Validators.required, Validators.maxLength(40)]],
        last_name: [userData.last_name, [Validators.required, Validators.maxLength(40)]],
        phone: [userData.phone, [Validators.required, Validators.pattern(/^[0-9]{10,11}$/)] ],
        company_name: [userData.company_name, [Validators.required, Validators.minLength(3), Validators.maxLength(40)]]
      });
    } else {
      this.updateMemberForm = this.fb.group({
        first_name: [userData.first_name, [Validators.required, Validators.maxLength(40)]],
        last_name: [userData.last_name, [Validators.required, Validators.maxLength(40)]],
        phone: [userData.phone, [Validators.required, Validators.pattern(/^[0-9]{10,11}$/)] ],
      });
    }
  }

  submit(value) {
    if (!this.updateMemberForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    data.country_code = this.selectedCountry.alpha_code;
    this.updateMembers(data);
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  updateMembers(data) {
    data = this.helperService.updateJsonFormat(data);
    this.memberService.updateMember({
      Authorization: this.accessToken,
      body: data
    }).subscribe((response: any) => {
      this.userData = response && response.data ? response.data : undefined;
      this.loader = false;
      this.authService.setMembersData(response && response.data ? response.data : undefined);
      this.resetForm();
      this.successMsg = 'Profile was changed sucessfully.';
      setTimeout(() => {
        this.router.navigate(['/member/settings/profile']);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.resetFormValues();
  }

  resetFormValues() {
    if (this.companyRoles === 'user') {
      this.updateMemberForm.reset({
        first_name: this.userData.first_name,
        last_name: this.userData.last_name,
        phone: this.userData.phone,
      });
    } else {
      this.updateMemberForm.reset({
        first_name: this.userData.first_name,
        last_name: this.userData.last_name,
        phone: this.userData.phone,
        company_name: this.userData.company_name,
      });
    }
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while updating profile.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
     return false;
    }
    if (e.which === 0) {
     return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
   }

}
